import { ILoadingScreen } from "babylonjs";

export class Loading implements ILoadingScreen {
  private loadingScreenDivComplex = window.document.getElementById(
    "loadingScreenComplex"
  );
  private showing = false;
  public loadingUIBackgroundColor: string;
  constructor(public loadingUIText: string) {}

  public displayLoadingUI() {
    if (!this.showing) {
      this.showing = true;
      this.loadingScreenDivComplex.style.removeProperty("display");
      this.loadingScreenDivComplex.style.removeProperty("visibility");
      this.loadingScreenDivComplex.classList.remove("visible");
    }
  }

  public hideLoadingUI() {
    if (this.showing) {
      this.showing = false;
      this.loadingScreenDivComplex.classList.add("animation-container-hidden");
    }
  }
}
